import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-customsoftware',
  templateUrl: './service-customsoftware.component.html',
  styleUrls: ['./service-customsoftware.component.css']
})
export class ServiceCustomsoftwareComponent implements OnInit {

  //constructor(){}
  //commentted and new code added by Digvijay on 18-06-2019
  constructor(private meta: Meta,private titleService: Title) {
    this.meta.addTag({ name: 'description', content: 'Custom Software Development - Our Experienced software engineers take charge of converting your business logic into scalable solutions using different technology platforms. ' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'Custom Software Development,custom application development in  ny,custom application development in  ph,custom application development in  wc,custom application development in nj,custom application development in Philadelphia,custom software development ,custom-application-development-in-new-york,offshore software development company,ios app development,software development company,software development outsourcing,software testing service companies,software development company in nj,custom software development, custom application development company in nj,' },true);    
    this.titleService.setTitle('Custom Software Development | Shreemon');
  }

  ngOnInit() {
  }

}
